
/*
 * CONSTANTS
 */

export const DRAWER_OPEN   = 'OPEN';
export const DRAWER_CLOSE  = 'CLOSE';
